import { selectData } from '../../../utils/select-data';
import { requiredHeaders } from '../../../models/required-headers';
import { withJwt } from '../../../utils/with-jwt';
import { fleetStatsEnvironment } from '../fleet-stats-environment';
import { z } from 'zod/v4';
import { fromFetch } from 'rxjs/fetch';

/**
 * Gets weather events
 * @returns Weather events
 */
export function getDashboardDeviceStatsWeatherEvents(
  this: unknown,
  startDate: Date,
  endDate: Date
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          fleetStatsEnvironment.resolve(this)
            .dashboardDeviceStatsWeatherEventsUrl
        }?startTimestamp=${startDate.toISOString()}&endTimestamp=${endDate.toISOString()}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        count: z.number(),
        event: z.string(),
      })
    )
  );
}
